import { useTranslate, useNavigation } from '@pankod/refine-core'
import { useEffect } from 'react'
import { Row, Col, AntdLayout, Card, Typography, Form, Input, Button, message } from '@pankod/refine-antd'
import { resetPassword } from 'users'
import useVerifyUserLogged from 'CustomHook/useVerifyUserLogedIn'
import './style.less'
const { Text, Title } = Typography
export interface IResetPassword {
  email: string
}

export const ResetPasswordPage: React.FC = () => {
  const [form] = Form.useForm<IResetPassword>()
  const t = useTranslate()
  const { push } = useNavigation()

  const CardTitle = (
    <div style={{ textAlign: 'center' }}>
      <img style={{ width: '150px' }} src="/images/logo.jpg" width="100%" />
    </div>
  )

  useEffect(() => {
    const UserLogedIn = async () => {
      const token = await localStorage.getItem('nhostRefreshToken')
      if (token) {
        push('/')
      }
    }
    UserLogedIn()
  }, [])

  const success = (msg: string, type: string) => {
    form.resetFields()
    if (type === 'success') {
      message.success(msg)
    } else message.error(msg)
  }

  return (
    <AntdLayout>
      <Row
        justify="center"
        align="middle"
        style={{
          height: '100vh',
        }}
      >
        <Col xs={22}>
          <div style={{ maxWidth: '408px', margin: 'auto' }}>
            <Card title={CardTitle} headStyle={{ borderBottom: 0 }} style={{ border: 'none', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
              <Form<IResetPassword>
                layout="vertical"
                form={form}
                onFinish={values => {
                  resetPassword(values).then(response => {
                    form.resetFields()
                    if (response === 'OK') {
                      success('Email Sent', 'success')
                      push('/login')
                    } else {
                      success(response, 'danger')
                    }
                  })
                }}
                requiredMark={false}
              >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: 'Enter your email' },
                    { whitespace: true, message: 'Please avoid adding white spaces' },
                    { type: 'email', message: 'Add an valid email' },
                  ]}
                  hasFeedback
                >
                  <Input placeholder="Enter your email" />
                </Form.Item>

                <div style={{ float: 'right', marginTop: '10px', width: '100%' }}>
                  <Button type="primary" htmlType="submit" className="gradient-button" style={{ width: '100%' }}>
                    Send Email
                  </Button>
                </div>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  )
}
